import { z } from 'zod'

export enum ChangeSubscriptionOptionEnum {
  DOWNGRADE = 'downgrade',
  UPGRADE = 'upgrade',
  CANCEL = 'cancel',
  REACTIVATE = 'reactivate',
  ROLLBACK = 'rollback',
}

export type Charge = {
  id: string
  platform: string
  description?: string
  purchaseType: string
  amount: number
  amountWithDiscount: number
  discount: number
  paymentType: string
  chargeDate: Date
  card?: {
    last4: string
    exp_month: number
    exp_year: number
    brandCard: string
    wallet: string
  }
  academy: string
  productId: string
  firstPayment: boolean
}

export type Address = {
  city?: string
  country?: string
  line1?: string
  line2?: string
  postal_code?: string
  state?: string
}

export type CardParam = {
  last4: string
  expMonth: number
  expYear: number
  type:
    | 'mastercard'
    | 'visa'
    | 'amex'
    | 'diners'
    | 'unionpay'
    | 'discover'
    | 'eftpos_au'
    | 'jcb'
    | 'unknown'
}

export type Customer = {
  fullName?: string
  email: string
  dniNie?: string
  phone?: string
  address?: Address
}

export type Billing = {
  card?: CardParam
  wallet?: 'apple_pay' | 'google_pay' | 'other'
  customer: Customer
}

export type BillingHistory = Charge & {
  description: string
  hasInvoice: boolean
}

export type ExternalCustomer = { platformCustomerId: string; platform: string }

export type SuscriptionChange = {
  email: string
  currentPurchaseId: string
  productId?: number
  action: ChangeSubscriptionOptionEnum
  callbackUrl?: string
}

export type VerificationAction = {
  email: string
  paymentIntent: string
  callbackUrl: string
}

export type CalculateUpgradeResponse = {
  success: boolean
  items: { amount: number; description: string; paymentPeriodicity: string }[]
  newPlanDescription: string
  /** Importe a cobrar hoy (invoice.amount_due de Stripe). */
  amount: number
  /** invoice.total. Si es negativo no se cobra: queda como saldo a favor. */
  total?: number
  discount: number
  billingRequired: boolean
}
export type CalculateUpgradeResponseError = {
  success: boolean
  code: number
  error: string
}

const sequraCheckoutSchema = z.object({
  invoiceId: z.string(),
  sequraId: z.string(),
})

export type SequraCheckoutInvoice = z.infer<typeof sequraCheckoutSchema>
export const validateSequraCheckout = (input) =>
  sequraCheckoutSchema.parse(input)
